<template>
  <div class="edit-sort-dialog">
    <el-dialog :title="title" class="dialog" width="468px" append-to-body @close="onClose" :visible="visible" :close-on-click-modal="false">
      <el-form ref="form" :rules="formRules" :model="formData" class="form" label-position="top" :inline="false">
        <el-form-item label="分类：" prop="name">
          <el-input v-model.trim="formData.name" placeholder="请输入分类名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="项目类型：" required prop="businessType">
          <el-radio-group v-model="formData.businessType" :disabled="isBusinessTypeDisable">
            <el-radio v-for="item in questionFormType.selectOptionList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">取消</el-button>
        <el-button size="small" :loading="loading" type="primary" @click="onOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { questionFormType } from "../questionBankUtils";
  import * as questionCatalogService from "@/modules/newCommunity/pages/operationTools/api/questionCatalogService";
  import questionnaireMixin from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/questionnaireMixin";

  export default {
    mixins: [questionnaireMixin],
    data() {
      return {
        questionFormType,
        isBusinessTypeDisable: false,
        visible: false,
        title: "",
        isEditModel: false,
        isAddModel: false,
        loading: false,
        formRules: {
          name: [
            {
              required: true,
              message: "请填写分类名称",
            },
          ],
        },
        formData: {
          name: "",
          businessType: questionFormType.QUESTIONNAIRE,
        },
      };
    },
    created() {
      this.formData.communityType = this.communityType;
    },
    methods: {
      onOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true;
            questionCatalogService
              .insertOrUpdate(this.formData)
              .then((res) => {
                if (res.code == 200) {
                  this.onClose();
                  if (this.isAddModel) {
                    this.$message.success("新建分类成功");
                  } else {
                    this.$message.success("更新分类成功");
                  }
                  this.$emit("onOk");
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      },
      onShow(params = { formData: {} }) {
        this.isBusinessTypeDisable = Boolean(params.isBusinessTypeDisable);
        this.formData = {
          ...this.formData,
          ...params.formData,
        };
        if (params.model == "edit") {
          this.isEditModel = true;
          this.title = "编辑分类";
        } else {
          this.isAddModel = true;
          this.title = "新增分类";
        }
        this.visible = true;
      },

      onClose() {
        this.$emit("close");
      },
    },
  };
</script>
<style scoped lang="less">
  @import "~@/styles/variable.less";

  .edit-sort-dialog {
    .form {
      .small-form(30px, 100px, 24px);
    }

    /deep/ .el-form-item {
      display: block !important;

      label {
        text-align: left !important;
      }
    }

    /deep/ .el-form-item:last-child {
      margin-bottom: 0;
    }
  }
</style>
